import * as Routes from '../../scripts/routes';
import { notification } from 'antd';

do ->
  'use strict'

  # ANGULAR CONTROLLER FUNCTION
  TelefonesSetoresController = ($http, $scope, $timeout) ->
    vm = @

    # CONSTANTS


    # VARIABLES VIEW MODEL
    vm.sortColumnName           = 'tree'
    vm.reverseColumnName        = false
    vm.current_orgao_id         = null
    vm.lotacoes_telefones_dados = null


    # VARIAVEIS PRIVATE


    # WATCHES


    # INIT SETUP
    init = () =>
      return


    # METHODS VIEW MODEL

    vm.sortColumn = (name) ->
      vm.reverseColumnName = if vm.sortColumnName == name then !vm.reverseColumnName else true;
      vm.sortColumnName    = name

    vm.addNumero = (lotacao) ->
      valor = Object.assign({}, lotacao.input_add)
      valor.num = valor.num.replace(/_/g, '')
      if valor.num.length > 13 && !lotacao.numeros_json.find((n) -> n.num == valor.num)
        lotacao.numeros_json.push(valor)
        $timeout((-> mask_telefone()), 100)
        lotacao.input_add = { num: '', tel: true, zap: false }
      return
    vm.removeNumero = (lotacao, index) ->
      lotacao.numeros_json.splice(index, 1);
      return
    vm.changeInputTelefone = (lotacao, item, index) ->
      lotacao.numeros_json[index].num = item
      return

    vm.addEmail = (lotacao) ->
      valor = lotacao.input_add_email # .replace(/_/g, '')
      if lotacao.emails == null
        lotacao.emails = []
      if valor.length > 7 && lotacao.emails.indexOf(valor) == -1
        lotacao.emails.push(valor)
        lotacao.input_add_email = ''
      return
    vm.removeEmail = (lotacao, index) ->
      lotacao.emails.splice(index, 1);
      return
    vm.changeInputEmail = (lotacao, item, index) ->
      lotacao.emails[index] = item
      return

    vm.editNumero = (lotacao) ->
      lotacao.edit = !lotacao.edit
      return

    vm.cancelarEdit = (lotacao) ->
      lotacao.edit = false
      return

    vm.saveNumeros = (telefone_setor) ->
      # email = (/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i).test(telefone_setor.email)

      if telefone_setor.id?
        $http.put(Routes.telefone_setor_path(telefone_setor.id), {
          setor_id:     telefone_setor.setor_id,
          emails:       telefone_setor.emails,
          numeros_json: telefone_setor.numeros_json,
        }).then ((result) ->
          if result.status == 200
            telefone_setor.edit = false
            notification.success({
              message:     'Sucesso',
              description: 'Telefones Salvos',
              placement:   'bottomRight'
            })
          return
        ), (error) ->
          notification.error({
            message:     'Erro',
            description: error.data.message,
            duration:    10,
            placement:   'bottomRight'
          })
        return
      else
        # if telefone_setor.numeros_json.length > 0 || email
        $http.post(Routes.telefones_setores_path(), {
          setor_id:     telefone_setor.setor_id,
          emails:       telefone_setor.emails,
          numeros_json: telefone_setor.numeros_json,
        }).then ((result) ->
          if result.status == 200
            telefone_setor.id   = result.data.id
            telefone_setor.edit = false
            notification.success({
              message:     'Sucesso',
              description: 'Telefones Salvos',
              placement:   'bottomRight'
            })
          return
        ), (error) ->
          notification.error({
            message:     'Erro',
            description: error.data.message,
            duration:    10,
            placement:   'bottomRight'
          })
        return

        return

    # CALL INIT SETUP
    init()

    return


  # ANGULAR CONTROLLER
  angular.module('mainApp').controller 'TelefonesSetoresController', TelefonesSetoresController

  # ANGULAR INJECT DEPENDENCIES
  TelefonesSetoresController.$inject = ['$http', '$scope', '$timeout']

  # END BLOCK SCRIPT
  return
